import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import moment from 'moment';

import './index.css';

const b = cn('date');

interface Props {
    dateStart: string;
    color?: 'black' | undefined;
    format?: string | undefined;
}

export default class Date extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { dateStart, color } = this.props;
        let { format } = this.props;
        const { lang } = this.context;

        if (!format) {
            format = lang === 'ru' ? 'D MMMM YYYY' : 'MMMM DD, YYYY';
        }

        return (
            <span className={b({ color })}>
                {moment(dateStart)
                    .locale(lang)
                    .format(format)}
            </span>
        );
    }
}
